var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMinimize = function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.185 13.796 3.655-3.662v3.171a.69.69 0 0 0 1.382 0V8.47a.69.69 0 0 0-.69-.691H.694a.69.69 0 1 0 0 1.382h3.171L.204 12.815a.69.69 0 0 0 0 .98.69.69 0 0 0 .981 0ZM13.796.204a.69.69 0 0 0-.981 0L9.16 3.866V.695a.69.69 0 1 0-1.382 0V5.53c0 .382.31.691.69.691h4.837a.69.69 0 0 0 0-1.382h-3.171l3.662-3.655a.69.69 0 0 0 0-.98Z"
  }))));
};

export { SvgMinimize as ReactComponent };
export default __webpack_public_path__ + "64bcea684918cd9758676e28320d5f9a.svg";